import { Action } from '@ngrx/store';
import { StartupData } from './models/StartupData';

export const LOAD_APP_CONFIG = '[APP] Load App Config';
export const LOAD_APP_CONFIG_SUCCESS = '[APP] Load App Config Success';

export class LoadAppConfig implements Action {
  readonly type = LOAD_APP_CONFIG;
  constructor() { }
}
export class LoadAppConfigSuccess implements Action {
  readonly type = LOAD_APP_CONFIG_SUCCESS;
  constructor(public startupData: StartupData) { }
}

export type Actions = LoadAppConfig | LoadAppConfigSuccess;
